import * as React from 'react';
import { LinkProps } from 'react-router-dom';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button, { ButtonProps } from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';
import HashLink from './Common/HashLink';
import { isUserAdmin } from '../api/auth';
import logo from '../ags_logo_white.png';

const jss = (theme: Theme) => createStyles({
    header: {
        position: 'relative',
    },
    headerToolbar: {
        maxWidth: 960,
        width: '100%',
        margin: '0px auto',
        height: 80,
    },
    headerLogo: {
        height: 64,
        width: 'auto',
    },
    largeNav: {
        display: 'none',
        '@media (min-width: 960px)': {
            display: 'initial',
        },
    },
    smallNav: {
        '@media (min-width: 960px)': {
            display: 'none',
        },
    },
    title: {
        paddingLeft: 10,
        flex: '1 1 auto',
    },
});

interface Props extends WithStyles<typeof jss> {}

interface State {
    expanded: boolean;
}

export class Header extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: false,
        }
    }

    private open = () => {
        this.setState({ expanded: true });
    }

    private close = () => {
        this.setState({ expanded: false });
    }

    render() {
        const showAdmin = isUserAdmin();
        const { classes } = this.props;
        const QuizLink = (props: LinkProps & ButtonProps)  => <HashLink to="/quiz" {...props} />
        const ScoreLink = (props: LinkProps & ButtonProps) => <HashLink to="/score" {...props} />
        const LeaderboardLink = (props: LinkProps & ButtonProps) => <HashLink to="/leaderboard" {...props} />
        // ONLY IF LOGGED IN USER IS ADMIN
        const AdminLink = (props: LinkProps & ButtonProps) => <HashLink to="/admin" {...props} />

        return (
            <AppBar className={classes.header}>
                <Toolbar className={classes.headerToolbar}>
                    <img src={logo} alt="AGS" className={classes.headerLogo} />
                    <Typography className={classes.title} variant="title" color="inherit" noWrap>
                        AGS 3DBee
                    </Typography>
                    <div className={classes.largeNav}>
                        <Button color="secondary" component={QuizLink}>
                            Quiz
                        </Button>
                        <Button color="secondary" component={ScoreLink}>
                            Score
                        </Button>
                        <Button color="secondary" component={LeaderboardLink}>
                            Leaderboard
                        </Button>
                        {showAdmin && <Button color="secondary" component={AdminLink}>
                            Admin
                        </Button>}
                    </div>
                    <div className={classes.smallNav}>
                        <IconButton onClick={this.open} color="inherit"><Menu fontSize="large" /></IconButton>
                        <Collapse in={this.state.expanded} unmountOnExit timeout="auto">
                            <AppBar style={{ paddingBottom: 30 }}>
                                <Toolbar className={classes.headerToolbar}>
                                    <img src={logo} alt="AGS" className={classes.headerLogo} />
                                    <Typography className={classes.title} variant="title" color="inherit" noWrap>
                                        AGS 3DBee
                                    </Typography>
                                    <IconButton onClick={this.close} color="inherit"><Menu fontSize="large" /></IconButton>
                                </Toolbar>
                                <Button color="secondary" size="large" onClick={this.close} component={QuizLink}>
                                    Quiz
                                </Button>
                                <Button color="secondary" size="large" onClick={this.close} component={ScoreLink}>
                                    Score
                                </Button>
                                <Button color="secondary" size="large" onClick={this.close} component={LeaderboardLink}>
                                    Leaderboard
                                </Button>
                                {showAdmin && <Button color="secondary" size="large" onClick={this.close} component={AdminLink}>
                                    Admin
                                </Button>}
                            </AppBar>
                        </Collapse>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(jss)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.tsx